import { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router';
import { isInternalFrom } from '@/types/navigation';

/**
 * Hook for context-aware "Torna indietro" navigation.
 * Uses location.state.from when present and valid (internal path);
 * otherwise uses fallbackPath (e.g. when arriving via external link or refresh).
 *
 * @param fallbackPath - Path to use when state.from is missing or invalid
 * @returns backPath (for Link to={backPath}) and goBack() (for onClick)
 */
export function useBackLink(fallbackPath: string): { backPath: string; goBack: () => void } {
    const location = useLocation();
    const navigate = useNavigate();

    const from = (location.state as { from?: string } | null)?.from;
    const backPath =
        from && isInternalFrom(from) ? from : fallbackPath;

    const goBack = useCallback(() => {
        navigate(backPath);
    }, [navigate, backPath]);

    return { backPath, goBack };
}
